/* ALL DAY FIRE - explainer video pill + lightbox behaviour (sections/adf-video-pill.liquid) */
(function () {
  if (customElements.get('adf-video-pill')) return;

  customElements.define('adf-video-pill', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.adfReady) return;
      this.dataset.adfReady = '1';
      this.host = this.querySelector('[data-adf-vp-host]');
      this.pill = this.querySelector('[data-adf-vp-open]');
      this.modal = this.querySelector('[data-adf-vp-modal]');
      this.frame = this.querySelector('[data-adf-vp-frame]');
      if (!this.pill || !this.modal) return;

      this.onKey = this.onKey.bind(this);
      this.onSectionLoad = this.onSectionLoad.bind(this);
      this.pill.addEventListener('click', () => this.open());
      /* Any link to #adf-play-video on the page (e.g. the hero's primary button) opens this lightbox too. */
      this.onDocClick = (e) => {
        var a = e.target.closest('a[href$="#adf-play-video"], [data-adf-video-open]');
        if (!a) return;
        e.preventDefault();
        this.open();
      };
      document.addEventListener('click', this.onDocClick);
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal || e.target.closest('[data-adf-vp-close]')) this.close();
      });
      var cta = this.querySelector('[data-adf-vp-cta]');
      if (cta) cta.addEventListener('click', (e) => {
        var href = cta.getAttribute('href') || '#';
        if (href.charAt(0) === '#') {
          e.preventDefault();
          this.close();
          /* "#" alone = jump to the offer stack / add-to-cart of the ADF product section */
          var target = href.length > 1 ? document.querySelector(href) : null;
          if (!target) target = document.querySelector('[data-adf-offer], [data-adf-atc], form[data-type="add-to-cart-form"]');
          if (target && target.scrollIntoView) setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 240);
        } else {
          this.close();
        }
      });

      this.mount();
      document.addEventListener('shopify:section:load', this.onSectionLoad);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      if (this.onDocClick) document.removeEventListener('click', this.onDocClick);
      if (this.observer) this.observer.disconnect();
      if (this.pill && this.pill.parentNode && this.pill.parentNode !== this.host) this.pill.remove();
      this.unlock();
    }

    findStage() {
      var sel = this.dataset.target || '.adf-pdp__stage';
      var stages = Array.prototype.slice.call(document.querySelectorAll(sel));
      return stages.find((el) => el.closest('adf-video-pill') === null) || null;
    }

    mount() {
      var stage = this.findStage();
      if (!stage) {
        this.host.classList.add('adf-vp__host--fallback');
        if (!this.host.contains(this.pill)) this.host.appendChild(this.pill);
        return;
      }
      this.host.classList.remove('adf-vp__host--fallback');
      if (this.pill.parentNode !== stage) stage.appendChild(this.pill);
      this.watchSlides(stage);
    }

    onSectionLoad() {
      /* The theme editor re-renders sections; mount() is idempotent, so just run it again. */
      if (this.pill) this.mount();
    }

    watchSlides(stage) {
      if (this.observer) this.observer.disconnect();
      if (this.dataset.hideOnVideo !== 'true') return;
      var update = () => {
        var active = stage.querySelector('.adf-pdp__slide.is-active');
        var isVideo = !!(active && (active.classList.contains('adf-pdp__slide--facility') || active.querySelector('video, iframe, model-viewer')));
        this.pill.hidden = isVideo;
      };
      update();
      this.observer = new MutationObserver(update);
      this.observer.observe(stage, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }

    open() {
      if (this.modal.classList.contains('is-open')) return;
      this.returnFocus = document.activeElement;
      var iframe = document.createElement('iframe');
      iframe.src = this.dataset.embed;
      iframe.title = (this.querySelector('.adf-vp__title') || {}).textContent || 'Video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      this.frame.innerHTML = '';
      this.frame.appendChild(iframe);

      this.modal.hidden = false;
      this.modal.classList.add('is-open');
      this.lock();
      requestAnimationFrame(() => requestAnimationFrame(() => this.modal.classList.add('is-visible')));
      document.addEventListener('keydown', this.onKey);
      var closeBtn = this.modal.querySelector('[data-adf-vp-close]');
      if (closeBtn) setTimeout(() => closeBtn.focus(), 60);
      this.track('open');
    }

    close() {
      if (!this.modal.classList.contains('is-open')) return;
      this.modal.classList.remove('is-visible');
      document.removeEventListener('keydown', this.onKey);
      this.unlock();
      setTimeout(() => {
        this.modal.classList.remove('is-open');
        this.modal.hidden = true;
        this.frame.innerHTML = '';
        if (this.returnFocus && this.returnFocus.focus) this.returnFocus.focus();
      }, 230);
      this.track('close');
    }

    onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
      if (e.key === 'Tab') {
        var focusables = this.modal.querySelectorAll('button, a[href], iframe, [tabindex]:not([tabindex="-1"])');
        if (!focusables.length) return;
        var first = focusables[0], last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    lock() { document.body.classList.add('adf-vp-locked'); }
    unlock() { document.body.classList.remove('adf-vp-locked'); }

    track(action) {
      try {
        var detail = { action: action, video_id: this.dataset.videoId, section: this.dataset.sectionId };
        document.dispatchEvent(new CustomEvent('adf:video:' + action, { detail: detail }));
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push({ event: 'adf_explainer_video', adf_action: action, adf_video_id: this.dataset.videoId });
        }
      } catch (e) {}
    }
  });
})();